import { useParams, Link } from "react-router-dom";
import { LEGAL_BY_SLUG } from "../data/legalContent";

function openCookiePrefs() {
  window.dispatchEvent(new CustomEvent("open-cookie-prefs"));
}

export default function LegalPage() {
  const { page } = useParams();

  if (page === "cookies") {
    return (
      <div data-testid="legal-page" className="mx-auto max-w-[760px] px-5 sm:px-8 py-20">
        <p className="mono-label">Legal</p>
        <h1 className="mt-4 font-display text-4xl tracking-tight">Cookie Preferences</h1>
        <p className="mt-8 text-base text-foreground/75 leading-relaxed">
          We use cookies and similar technologies to operate our website, remember your privacy preferences, and
          understand how our content is used. Essential cookies are always on. Analytics cookies are optional.
        </p>
        <button data-testid="open-cookie-prefs-btn" onClick={openCookiePrefs}
          className="mt-8 inline-flex items-center gap-2 bg-primary text-primary-foreground font-medium text-sm px-6 py-3 hover:bg-primary-hover transition-colors">
          Manage Cookie Preferences
        </button>
        <p className="mt-8 text-sm text-foreground/60">
          For full details, see our <Link to="/legal/privacy" className="text-primary hover:underline">Privacy & Cookie Policy</Link>.
        </p>
      </div>
    );
  }

  const doc = LEGAL_BY_SLUG[page] || LEGAL_BY_SLUG.terms;

  return (
    <div data-testid="legal-page" className="mx-auto max-w-[760px] px-5 sm:px-8 py-20">
      <p className="mono-label">Legal</p>
      <h1 className="mt-4 font-display text-4xl tracking-tight">{doc.title}</h1>
      <p className="mt-3 font-mono text-xs uppercase tracking-widest text-muted-foreground">{doc.effective}</p>
      <div className="mt-10 space-y-9">
        {doc.blocks.map((b, i) => (
          <section key={i}>
            {b.h && <h2 className="font-display text-xl font-medium tracking-tight text-foreground">{b.h}</h2>}
            <div className={b.h ? "mt-3 space-y-3" : "space-y-3"}>
              {b.p?.map((para, j) => <p key={j} className="text-sm text-foreground/70 leading-relaxed">{para}</p>)}
              {b.ul && (
                <ul className="space-y-2 pl-1">
                  {b.ul.map((li, j) => (
                    <li key={j} className="flex gap-3 text-sm text-foreground/70 leading-relaxed"><span className="text-primary mt-1">-</span>{li}</li>
                  ))}
                </ul>
              )}
              {b.after?.map((para, j) => <p key={j} className="text-sm text-foreground/70 leading-relaxed">{para}</p>)}
            </div>
          </section>
        ))}
      </div>
      <Link to="/" className="mt-12 inline-block font-mono text-[11px] uppercase tracking-widest text-primary">← Back home</Link>
    </div>
  );
}
